import React, { useState } from 'react';
import { RiDownload2Line } from 'react-icons/ri';

import { alert } from 'lib/alert';
import { downloadInvoiceFileService } from 'services/invoice_file.service';

import { DownloadButton } from './invoice-download-button.styles';

interface InvoiceDownloadButtonProps {
  invoiceId: string;
  // Só o ícone (listas estreitas / mobile); o rótulo continua no title/aria.
  iconOnly?: boolean;
}

/**
 * Baixa o PDF original da fatura (para consulta ou para facilitar o pagamento).
 * Compartilhado pelas listas de faturas do cliente (aba da UC, "Minhas
 * faturas" do dashboard/UCs e a versão mobile). O arquivo vem de
 * GET /invoices/:id/file — o backend confere que a fatura é da conta e responde
 * 404 quando o PDF não está arquivado; a mensagem dele é exibida em toast.
 */
export const InvoiceDownloadButton = ({
  invoiceId,
  iconOnly = false,
}: InvoiceDownloadButtonProps) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const { blob, filename } = await downloadInvoiceFileService(invoiceId);

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert.error((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DownloadButton
      type="button"
      onClick={handleDownload}
      disabled={loading}
      title="Baixar a fatura em PDF"
      aria-label="Baixar a fatura em PDF"
    >
      <RiDownload2Line size={16} />
      {!iconOnly && <span>{loading ? 'baixando...' : 'baixar fatura'}</span>}
    </DownloadButton>
  );
};
